import styled from "styled-components";
import { Card } from "@teals/ui-web";

export const HubStats = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.75rem;
`;

export const HubStat = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.75rem;
  color: var(--text-muted);
  background: var(--bg-elevated);
  padding: 0.25rem 0.625rem;
  border-radius: 999px;

  strong {
    color: var(--text-primary);
  }
`;

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding-bottom: 1.5rem;
`;

export const ActionBarSpacer = styled.div`
  flex: 1;
`;

export const CatalogGroup = styled.section`
  margin-bottom: 2rem;
`;

export const CatalogGroupTitle = styled.h3`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  margin: 0 0 0.75rem;
`;

export const CatalogTile = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border: 1px solid var(--border);
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 100%;
`;

export const CatalogTileHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
`;

export const CatalogTileTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
`;

export const CatalogTileDesc = styled.p`
  font-size: 0.8125rem;
  color: var(--text-muted);
  line-height: 1.45;
  margin: 0;
  flex: 1;
`;

export const CatalogTileFoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--border);
  margin-top: auto;
`;

export const CatalogMeta = styled.span`
  font-size: 0.75rem;
  color: var(--text-muted);
`;

export const Crumb = styled.nav`
  font-size: 0.8125rem;
  color: var(--text-muted);
  margin-bottom: 0.75rem;
  overflow-wrap: anywhere;

  a {
    color: var(--accent);
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export const InstanceHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

export const InstanceActions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
`;

export const InstanceTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const ConnectionStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  padding: 1rem 1.25rem;
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  margin-bottom: 1.5rem;
  min-width: 0;
`;

export const StripItem = styled.div`
  min-width: 0;
  flex: 1 1 8.5rem;

  label {
    display: block;
    font-size: 0.6875rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--text-muted);
    margin-bottom: 0.25rem;
  }

  span {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--text-primary);
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;

export const ComingSoonLayout = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 0.9fr;
  gap: 1.25rem;
  min-width: 0;

  > * {
    min-width: 0;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const Panel = styled.div`
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  min-width: 0;
  overflow-x: auto;

  h2 {
    font-size: 0.875rem;
    font-weight: 600;
    margin: 0 0 0.75rem;
    color: var(--text-primary);
  }
`;

export const ProviderLogo = styled.div<{ $bg: string }>`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${(p) => p.$bg};
  color: #fff;
  font-weight: 700;
  display: grid;
  place-items: center;
  font-size: 0.875rem;
  flex-shrink: 0;
`;

export const InfoBanner = styled.div`
  display: flex;
  gap: 0.5rem;
  background: var(--info-subtle, rgba(59, 130, 246, 0.06));
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  margin-bottom: 1rem;
`;

export const LifecycleTable = styled.table`
  width: 100%;
  font-size: 0.8125rem;
  border-collapse: collapse;

  th,
  td {
    text-align: left;
    padding: 0.625rem 0.5rem;
    border-bottom: 1px solid var(--border);
    vertical-align: top;
  }

  th {
    color: var(--text-muted);
    font-size: 0.6875rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
  }
`;
